export enum AnnotationObjectIdEnum {
  SelectPointer = 0,
  Line = 1,
  Rectangle = 2,
  Ellipse = 3,
  Arrow = 4,
  Redaction = 5,
  FreeHand = 6,
  Text = 7,
  TextPointer = 8,
  Stamp = 9,
  Ruler = 10,
  PolyRuler = 11,
  Hilite = 12
}
